import React from "react";
import DropDownComponent from "../DropDownComponent";
import DropDownComponentSorted from "../DropDownComponentSorted";
import InputComponent from "../InputComponent";
import PhoneNumberInput from "../PhoneNumberInput";
import TextFieldComponent from "../TextFieldComponent";

function EmergencyContact({
  emergencyContactFirstName,
  handleEmergencyContactFirstNameChange,
  emergencyContactLastName,
  handleEmergencyContactLastNameChange,
  emergencyContactRelationship,
  handleEmergencyContactRelationshipChange,
  emergencyRelationshipOther,
  handleEmergencyRelationshipOther,
  emergencyContactPhoneNumber,
  handleEmergencyContactPhoneNumberChange,
  emergencyContactEmail,
  handleEmergencyContactEmailChange,
  emergencyContactAddress,
  handleEmergencyContactAddressChange,
  emergencyContactCity,
  handleEmergencyContactCityChange,
  provinceEmergencyContact,
  handleProvinceEmergencyContactChange,
  emergencyContactNationality,
  handleEmergencyContactNationalityChange,
  emergencyContactCountry,
  handleEmergencyContactCountryChange,
  payerName,
  handlePayerNameChange,
  payerPhoneNumber,
  handlePayerPhoneNumberChange,
}) {
  return (
    <section className="general-information-emergency-card">
      <div className="general-information-heading">
        <span className="general-information-kicker">Safety &amp; contacts</span>
        <h2>Emergency Contact</h2>
        <p>Primary contact and treatment payment information</p>
      </div>
      <div className="general-information-emergency-section">
        <h3>Contact details</h3>
        <div className="general-information-emergency-grid">
          <InputComponent
            title="Emergency contact first name"
            width="auto"
            value={emergencyContactFirstName}
            onChange={handleEmergencyContactFirstNameChange}
          />
          <InputComponent
            title="Emergency contact last name"
            width="auto"
            value={emergencyContactLastName}
            onChange={handleEmergencyContactLastNameChange}
          />
          <DropDownComponentSorted
            api="relationship"
            title="Relationship"
            value={emergencyContactRelationship}
            onChange={handleEmergencyContactRelationshipChange}
          />

          {emergencyContactRelationship === "Other" ? (
            <InputComponent
              title="If other, describe"
              width="100px"
              value={emergencyRelationshipOther}
              onChange={handleEmergencyRelationshipOther}
            />
          ) : (
            ""
          )}

          <PhoneNumberInput
            title="Contact phone number"
            value={emergencyContactPhoneNumber}
            onChange={handleEmergencyContactPhoneNumberChange}
          />

          <InputComponent
            title="Contact Email"
            width="auto"
            value={emergencyContactEmail}
            onChange={handleEmergencyContactEmailChange}
          />
        </div>

        <div className="general-information-emergency-section">
          <h3>Address</h3>
          <div className="general-information-emergency-grid general-information-emergency-grid-address">
            <div className="general-information-address-field">
              <TextFieldComponent
                title="Physical address of residence"
                value={emergencyContactAddress}
                onChange={handleEmergencyContactAddressChange}
                width="500px"
              />
            </div>
            <InputComponent
              title="City"
              width="auto"
              value={emergencyContactCity}
              onChange={handleEmergencyContactCityChange}
            />
            <InputComponent
              title="State / Province"
              width="auto"
              value={provinceEmergencyContact}
              onChange={handleProvinceEmergencyContactChange}
            />
          </div>
        </div>
        <div className="general-information-emergency-section">
          <h3>Location</h3>
          <div className="general-information-emergency-grid general-information-emergency-grid-location">
            <DropDownComponent
              api="nationalities"
              title="Nationality"
              value={emergencyContactNationality}
              onChange={handleEmergencyContactNationalityChange}
            />
            <DropDownComponentSorted
              api="countries"
              title="Country"
              value={emergencyContactCountry}
              onChange={handleEmergencyContactCountryChange}
            />
          </div>
        </div>

        <div className="general-information-emergency-section">
          <h3>Payment contact</h3>
          <div className="general-information-emergency-grid general-information-emergency-grid-payment">
            <InputComponent
              title="Name of the person paying for the treatment"
              width="auto"
              value={payerName}
              onChange={handlePayerNameChange}
            />
            <PhoneNumberInput
              title="Phone number of person paying"
              value={payerPhoneNumber}
              onChange={handlePayerPhoneNumberChange}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default EmergencyContact;
